import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { LoginUser } from 'src/app/shared/models/users/signupUser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm = true;
  public errors = [];

  constructor(
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService
  ) {
  }

  ngOnInit(): void {
  }

  login(userData: LoginUser) {
    this.spinner.show();
    this.authService.login(userData).subscribe(
      p => {
        this.spinner.hide();
        this.router.navigate(['/']);
      }
    );
  }

  resetPassword(username) {
    this.spinner.show();
    this.authService.resetPassword(username).subscribe(
      p => {
        this.spinner.hide();
        this.toastr.success('You have received an email with a new password!', 'Password Reset!');
        this.loginForm = true;
      }
    );
  }
}
